export default __webpack_public_path__ + "static/media/leaf.6c542c9a.svg";